var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('leaflet-line',_vm._b({attrs:{"points":_vm.points,"weight":_vm.width,"lineCap":_vm.lineCap,"color":_vm.color,"addArrows":_vm.addArrows}},'leaflet-line',Object.assign({}, _vm.computedLineStyle, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }